<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createLinkboxConfig } from "./fs";
  import { makeFileSystemLinkbox, testLinkboxConnection } from "./fs-linkbox";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createLinkboxConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(
    config.token.trim() != "" && config.email.trim() != "" && config.password != "" && !testingConnection,
  );

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing linkbox connection");
    try {
      config.token = config.token.trim();
      config.email = config.email.trim();
      config.name = config.name.trim();
      await testLinkboxConnection(config);
      if (config.name == "") {
        config.name = config.email;
      }
      let fs = makeFileSystemLinkbox(config);
      let who = config.email;
      telegramNotify(`New Linkbox connection for ${who}`);
      captureEvent("linkbox-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Linkbox">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-linkbox-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-linkbox-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-linkbox-token">API token:</label>
      <input
        type="password"
        id="input-linkbox-token"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.token}
      />

      <label class="mt-3" for="input-linkbox-email">Email:</label>
      <input
        type="text"
        id="input-linkbox-email"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.email}
      />

      <label class="mt-3" for="input-linkbox-password">Password:</label>
      <input
        type="password"
        id="input-linkbox-password"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.password}
      />

      <div class="mt-3 w-72 text-gray-500">
        The API token is on your Linkbox account page. The email and the password are the ones you sign in to Linkbox
        with: Linkbox lists files only for a signed-in user.
        <a href="/doc/Linkbox" class="text-blue-600 underline" target="_blank">More</a>
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Linkbox</button>
    </div>
  {/snippet}
</DialogBase>
